/**
FX

An audio FX output network. Currently experimenting with a fixed network
with some params.

Status: WIP
*/

{ FFT_SIZE, SCOPE_FFT_SIZE } from ../const.civet

attachLFO := (node: AudioNode, attribute: string, {frequency, amplitude}:{frequency: number, amplitude: number}) ->
  {context} := node

  lfo := context.createOscillator()
  lfo.frequency.value = frequency
  lfo.start()

  gain := context.createGain()
  gain.gain.value = amplitude

  // @ts-ignore
  gain.connect node[attribute]

/**
input -> delay -> gain -> destination
      -> destination
*/
// Simple slapback delay
slapback := (destination: AudioNode) ->
  {context} := destination

  d1 := context.createDelay 0.1
  d1.delayTime.value = 0.035

  g1 := context.createGain()
  g1.gain.value = 0.42

  d1.connect g1
  g1.connect destination

  // Input
  input := context.createGain()
  input.gain.value = 0.88
  input.connect destination
  input.connect d1

  return input

/**                     -> feedback
input -> d1 -> g1 -> f1 -> destination
      -> d2 /
*/
cygnus := (destination: AudioNode) ->
  {context} := destination

  d1 := context.createDelay 0.1
  d1.delayTime.value = 0.069

  d2 := context.createDelay 0.5
  d2.delayTime.value = 0.171

  attachLFO d2, "delayTime",
    frequency: 1.3
    amplitude: 0.1

  g1 := context.createGain()
  g1.gain.value = 0.3

  feedback := context.createGain()
  feedback.gain.value = 0.75

  d1.connect g1
  d2.connect g1

  feedback.connect d1
  feedback.connect d2

  f1 := context.createBiquadFilter()
  f1.type = "bandpass"
  f1.frequency.value = 500
  f1.Q.value = 0.5

  g1.connect f1

  attachLFO f1, "frequency",
    frequency: 0.44
    amplitude: 420

  attachLFO f1, "Q",
    frequency: 0.77
    amplitude: 0.25

  // Input
  input := context.createGain()
  input.connect f1
  input.connect d1
  input.connect d2

  f1.connect feedback
  f1.connect destination

  return input

/**
input                                        -> input
      -> wet -> delay1 -> filter -> feedback -> destination
             -> delay2 -> feedback -> destination
                  |
                 lfo

      -> dry -> destination
*/
// Chorus
chorus := (destination: AudioNode) ->
  {context} := destination

  // Filtered delay
  d1 := context.createDelay(0.1)
  d1.delayTime.value = 0.005

  f1 := context.createBiquadFilter()
  f1.type = "highpass"
  f1.frequency.value = 1000

  d1.connect f1

  // Modulated delay
  d2 := context.createDelay(0.1)
  d2.delayTime.value = 0.007

  attachLFO d2, "delayTime",
    frequency: 2.64
    amplitude: 0.00308

  wetGain := context.createGain()
  wetGain.gain.value = 0.5

  wetGain.connect d1
  wetGain.connect d2

  dryGain := context.createGain()
  dryGain.gain.value = 0.5

  // Input
  input := context.createGain()
  input.connect dryGain
  input.connect wetGain
  dryGain.connect destination

  feedback := context.createGain()
  feedback.gain.value = 0.15
  feedback.connect input

  f1.connect destination
  f1.connect feedback
  d2.connect destination
  d2.connect feedback

  return input

/**
input -> wet -> delay -> filter -> destination
                  |            \-> feedback -> input
                 lfo
      -> dry -> destination
*/
// Flanger (Experimental)
flanger := (destination: AudioNode) ->
  {context} := destination

  // Filtered delay
  d1 := context.createDelay(0.01)
  d1.delayTime.value = 0.00073

  f1 := context.createBiquadFilter()
  f1.type = "lowpass"
  f1.frequency.value = 1000
  f1.Q.value = 0.5

  d1.connect f1

  attachLFO d1, "delayTime",
    frequency: 0.11
    amplitude: 0.00045

  wetGain := context.createGain()
  wetGain.gain.value = 1
  wetGain.connect d1

  dryGain := context.createGain()
  dryGain.gain.value = 0

  // Input
  input := context.createGain()
  input.connect dryGain
  dryGain.connect destination
  input.connect wetGain

  feedback := context.createGain()
  feedback.gain.value = 0.75
  feedback.connect input

  f1.connect feedback
  f1.connect destination

  return input

// Experimental
phaser := (destination: AudioNode) ->
  {context} := destination

  input := context.createGain()
  input.gain.value = 0.75

  lfo := context.createOscillator()
  lfo.frequency.value = 0.5
  lfo.start()

  attachLFO lfo, "frequency",
    amplitude: 0.25
    frequency: 0.25

  lfoGain := context.createGain()
  lfoGain.gain.value = 110
  lfo.connect lfoGain

  i .= 0
  prev .= input
  while i < 8
    i++

    f := context.createBiquadFilter()
    f.type = "allpass"
    f.frequency.value = i * 220
    f.Q.value = 16

    lfoGain.connect f.frequency

    if prev
      prev.connect f
      prev = f

  // Feedback delay
  d1 := context.createDelay(0.01)
  d1.delayTime.value = 0.0073

  feedback := context.createGain()
  feedback.gain.value = 0.45
  feedback.connect d1

  d1.connect input

  prev.connect feedback
  prev.connect destination

  return input

compressor :=  (destination: AudioNode) ->
  {context} := destination

  compressor := context.createDynamicsCompressor()
  compressor.attack.value = 0.0035
  compressor.connect destination

  wetGain := context.createGain()
  wetGain.gain.value = 0.5
  wetGain.connect compressor

  dryGain := context.createGain()
  dryGain.gain.value = 0.5

  // Input
  input := context.createGain()
  input.connect dryGain
  dryGain.connect destination
  input.connect wetGain

  return input

limiter :=  (destination: AudioNode) ->
  {context} := destination
  limiter := context.createDynamicsCompressor()

  limiter.threshold.value = 0 // leave some headroom
  limiter.knee.value = 0.0 // Hard Knee
  limiter.ratio.value = 20.0 // Max ratio
  limiter.attack.value = 0.005
  limiter.release.value = 0.01

  limiter.connect destination

  return limiter

sweepingPan := (destination: AudioNode) ->
  {context} := destination
  panner := context.createStereoPanner()

  lfo := context.createOscillator()
  lfo.frequency.value = 0.25
  lfo.type = "sine"
  lfo.start()

  attachLFO lfo, "frequency",
    frequency: 0.77
    amplitude: 0.125

  lfo.connect panner.pan

  panner.connect destination

  return panner

/**
Stereo Ping Pong Delay

From my brief research there seem to be a few different ways people wire up
these kind of stereo ping pong delays. My goal is to have it be relatively
simple, have the unmodified signal proceed through each channel, and have the
delayed signal on the opposite channel.

  ->
L -> DelayL -> GainL FeedbackL
                    X
R -> DelayR -> GainR FeedbackR
  ->

This diagram is pretty weak ;_;
*/
pingPongDelay := (destination: AudioNode) ->
  {context} := destination

  splitter := context.createChannelSplitter(2)
  merger := context.createChannelMerger(2)

  delayL := context.createDelay()
  delayL.delayTime.value = 0.045
  delayR := context.createDelay()
  delayR.delayTime.value = 0.024

  splitter.connect delayL, 0
  splitter.connect delayR, 1

  gainL := context.createGain()
  gainL.gain.value = 0.4
  gainR := context.createGain()
  gainR.gain.value = 0.4

  delayL.connect gainL
  delayR.connect gainR

  // Right swaps to left
  gainR.connect merger, 0, 0
  gainL.connect merger, 0, 1

  // Feedback crosses over
  gainL.connect delayR
  gainR.connect delayL

  // Raw signal goes straight through
  splitter.connect merger, 0, 0
  splitter.connect merger, 1, 1

  output := context.createGain()
  output.gain.value = 0.75
  output.connect destination

  merger.connect output

  return splitter

// Stereo analyser
export stereoAnalyser := (destination: AudioNode) ->
  {context} := destination

  splitter := context.createChannelSplitter(2)
  merger := context.createChannelMerger(2)

  maxDecibels := -6

  analyserL := context.createAnalyser()
  analyserL.smoothingTimeConstant = 0
  analyserL.maxDecibels = maxDecibels
  analyserL.fftSize = FFT_SIZE

  analyserR := context.createAnalyser()
  analyserR.smoothingTimeConstant = 0
  analyserR.maxDecibels = maxDecibels
  analyserR.fftSize = FFT_SIZE

  splitter.connect analyserL, 0
  splitter.connect analyserR, 1

  // A second pair for the waveform only, four times as long (~85 ms at 48 kHz). The vfx
  // scope shows ~43 ms of it, which holds several cycles of a bass note — the spectrum
  // pair's 1024 samples are shorter than one, so a scope drawn from them changes shape
  // every frame however it is triggered. Separate so the spectrum every shader is tuned
  // against keeps its bin count. Not connected onward: an analyser is pulled by its input.
  scopeL := context.createAnalyser()
  scopeL.fftSize = SCOPE_FFT_SIZE
  scopeR := context.createAnalyser()
  scopeR.fftSize = SCOPE_FFT_SIZE
  splitter.connect scopeL, 0
  splitter.connect scopeR, 1

  analyserL.connect merger, 0, 0
  analyserR.connect merger, 0, 1

  merger.connect destination

  Object.assign splitter,
    l: analyserL
    r: analyserR
    scope:
      l: scopeL
      r: scopeR

// 50/50 panner to ensure mono signal is stereo before going into ping pong delay
// etc.
defaultPanner := (destination: AudioNode) ->
  {context} := destination

  panner := context.createStereoPanner()
  panner.connect destination

  return panner

water := (destination: AudioNode) ->
  {context} := destination

  f1 := context.createBiquadFilter()
  f1.type = "bandpass"
  f1.frequency.value = 250
  f1.Q.value = 0.25

  f2 := context.createBiquadFilter()
  f2.type = "peaking"
  f2.frequency.value = 440 / 8
  f2.Q.value = 1
  f2.gain.value = 3

  f3 := context.createBiquadFilter()
  f3.type = "lowpass"
  f3.frequency.value = 197
  f3.Q.value = 1

  f1.connect f2
  f2.connect destination
  f3.connect destination

  g1 := context.createGain()
  g1.gain.value = 0.7
  g1.connect f3

  d1 := context.createDelay()
  d1.delayTime.value = 0.21
  d1.connect g1

  input := context.createGain()
  input.connect d1
  input.connect f1

  chorus input

none := (destination: AudioNode) ->
  {context} := destination

  g := context.createGain()
  g.connect destination

  return g

mapping :=
  purple: "slapback"
  psy: "phaser"


FX :=
  choices: [
    "none"
    "slapback"
    "cygnus"
    "phaser"
    "water"
  ] as const
  chorus: chorus
  compressor: compressor
  cygnus: cygnus
  defaultPanner: defaultPanner
  flanger: flanger
  limiter: limiter
  mapping: mapping
  none: none
  pingPongDelay: pingPongDelay
  // Simple slapback delay
  purple: slapback
  fire: (destination: AudioNode) ->
    flanger destination
  phaser: phaser
  psy: (destination: AudioNode) ->
    phaser destination
  slapback: slapback
  stereoAnalyser: stereoAnalyser
  sweepingPan: sweepingPan
  water: water

export default FX
